import Sidebar from './sidebar.json';
import Test from './test.json';
import login from './login.json';
import constituencyWiseResults from './constituencyWiseResults.json';
import centerWiseResults from './centerWiseResults.json';
import header from './header.json';
import Dashboard from './dashboard.json';

const translation = {
  translation: {
    TEST: Test,
    HEADER: header,
    SIDEBAR: Sidebar,
    LOGIN: login,
    DASHBOARD: Dashboard,
    CONSTITUENCY_WISE_RESULTS: constituencyWiseResults,
    CENTER_WISE_RESULTS: centerWiseResults,
  },
};

export default translation;
